import { render, staticRenderFns } from "./AreaForm.vue?vue&type=template&id=4f3e49f4&"
import script from "./AreaForm.vue?vue&type=script&lang=js&"
export * from "./AreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3e49f4')) {
      api.createRecord('4f3e49f4', component.options)
    } else {
      api.reload('4f3e49f4', component.options)
    }
    module.hot.accept("./AreaForm.vue?vue&type=template&id=4f3e49f4&", function () {
      api.rerender('4f3e49f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/BaseData/Venue/modules/AreaForm.vue"
export default component.exports